import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Stack, Spinner, SpinnerSize, useTheme } from '@fluentui/react';
import { Navigation } from './Navigation';
import { AppNotificationHost } from './notifications/AppNotificationHost';

/**
 * Layout component with navigation header
 * Wraps content in Suspense to support lazy-loaded route components
 */
export function Layout() {
  const theme = useTheme();

  return (
    <Stack styles={{ root: { height: '100vh', background: theme.palette.neutralLighter } }}>
      {/* Navigation header */}
      <Stack.Item>
        <Navigation />
      </Stack.Item>
      
      {/* Main content area with Suspense for lazy loading */}
      <Stack.Item grow styles={{ root: { overflow: 'auto', padding: '20px' } }}>
        <Suspense fallback={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spinner size={SpinnerSize.large} label="Loading..." />
          </div>
        }>
          <Outlet />
        </Suspense>
      </Stack.Item>
      <AppNotificationHost />
    </Stack>
  );
}

export default Layout;
